import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";

import CustomLoader from "../../component/CustomLoader/CustomLoader";
import "./style.css";
import api from "../../config/api";
import GradientButton from "../../component/GradientButton/GradientButton";
import TextInputOutline from "../../component/TextInputOutline/TextInputOutline";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import { isNetworkRequestFailedError } from "../../config/helpers";

class NewPassword extends Component {
  state = {
    isLoading: false,
    username: "",
    newPassword: "",
    newPasswordError: "",
    confirmPasswordError: "",
    confirmPassword: "",
    securityCode: "",
    securityCodeError: "",
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    const { localHistory } = this.props;

    if (!localHistory) {
      window.location.replace("/forgotpassword");
    }

    const forgotusername = localStorage.getItem("forgotusername");
    localStorage.removeItem("forgotusername");

    this.setState({ username: forgotusername });

    setHistory(history);
  }

  changeHandler = (e) => {
    const name = e.target.name;

    this.setState({
      [name]: e.target.value,
      [name + "Error"]: "",
    });
  };

  validatePassword = (password) => {
    // Min char 6, requires combination of numbers and letters
    const passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[0-9])(?=.{6,})");
    return passwordRegex.test(String(password).toLowerCase());
  };

  validate = () => {
    const errors = {};

    const { newPassword, confirmPassword } = this.state;

    if (!this.validatePassword(newPassword)) {
      errors.newPasswordError =
        "Password must atleast 6 characters long with combination of numbers and letters";
    }

    if (newPassword !== confirmPassword) {
      errors.newPasswordError = "Password do not match";
      errors.confirmPasswordError = "Password do not match";
    }

    this.setState({ ...errors });

    return Object.keys(errors).length;
  };

  newPassword = async (e) => {
    const { localHistory, setAlertMessage } = this.props;
    e.preventDefault();

    try {
      const { securityCode, newPassword, username } = this.state;

      const payload = {
        securityCode,
        newPassword,
        username,
      };

      if (this.validate()) return;

      this.setState({ isLoading: true });

      await api.newPassword(payload);

      setAlertMessage({ type: "success", message: "Success" });
      localHistory.push("/login");
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.newPassword(e)
          : null,
      });
    }
    this.setState({ isLoading: false });
  };

  render() {
    const {
      securityCode,
      isLoading,
      newPassword,
      newPasswordError,
      confirmPasswordError,
      confirmPassword,
      securityCodeError,
    } = this.state;

    return (
      <div className="login-main-container">
        <Container>
          <div className="login-container">
            <img
              alt="app-icon"
              src={require("../../assets/icons/app-icon.png")}
            />
            <p className="login-container-app-name">Premium Pension Limited</p>
            <h2 className="mt-4 font-weight-bold">New Password</h2>
            <form
              className="mb-5 mt-4 login-input-container align-items-start"
              onSubmit={this.newPassword}
            >
              <div className="my-2 w-100">
                <TextInputOutline
                  onChange={this.changeHandler}
                  value={securityCode}
                  name="securityCode"
                  label="Enter 6 digit security code"
                  errorMessage={securityCodeError}
                />
              </div>
              <div className="my-2 w-100">
                <TextInputOutline
                  name="newPassword"
                  type="password"
                  onChange={this.changeHandler}
                  value={newPassword}
                  label="New password"
                  errorMessage={newPasswordError}
                />
              </div>
              <div className="my-2 w-100">
                <TextInputOutline
                  name="confirmPassword"
                  type="password"
                  onChange={this.changeHandler}
                  value={confirmPassword}
                  label="Confirm password"
                  errorMessage={confirmPasswordError}
                />
              </div>
              <GradientButton
                type="submit"
                containerClasses="mt-4 mx-auto"
                label="Reset Password"
              />
              <div className="text-center w-100 mt-2">
                <Link className="back-to-login-text" to="/login">
                  Already a member? Login
                </Link>
              </div>
            </form>
          </div>
        </Container>
        {isLoading && <CustomLoader text="Please wait" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  localHistory: state.history.localHistory,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPassword);
